import Env from '@shared/environments/environment';

export const TOKEN_NAME = 'authToken';

export const USER_ROLE = 'USER_ROLE';

export const RETURN_URI = 'RETURN_URI';

export const SESSION_TIME = 'SESSION_TIME';

export const SESSION_STARTED_TIME = 'SESSION_STARTED_TIME';

export const SESSION_ENDED_TIME = 'SESSION_ENDED_TIME';

export const MINUTE = 1000 * 60;

export const SESSION_WARNING_TIME = 15 * 60;

export const MAX_LOGO_SIZE = 1;

export const DAY = 24 * 60 * MINUTE;

export const LOGO_EXT = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg+xml'];

export const LOGO_ACCEPT = '.jpg,.jpeg,.png,.svg';

export const NO_DEFAULT_ERRORS_HEADER = 'X-No-Default-Errors';

export const NO_DEFAULT_ERRORS = { 'X-No-Default-Errors': true };

export const PASSWORD_MIN_LENGTH = 6;

export const PASSWORD_MAX_LENGTH = 38;

export const SUFFIX = '/login';

export const REDIRECT_URL = `${Env.webSiteBaseUri}${SUFFIX}`;
